import { z } from "zod/v4"

import { organizationRoleSchema } from "@/http/organizations"

export const inviteSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  role: organizationRoleSchema,
  createdAt: z.string().datetime(),
  author: z.object({
    id: z.string(),
    name: z.string(),
    avatarUrl: z.string().nullable(),
  }),
})

export type TInvite = z.infer<typeof inviteSchema>

export const inviteFullSchema = inviteSchema.extend({
  organization: z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
  }),
})

export type TInviteFull = z.infer<typeof inviteFullSchema>

export const listInvitesResponseSchema = z.object({
  invites: z.array(inviteSchema),
})

export type TListInvitesResponse = z.infer<typeof listInvitesResponseSchema>

export const createInviteResponseSchema = z.object({
  inviteId: z.string(),
})

export type TCreateInviteResponse = z.infer<typeof createInviteResponseSchema>

export const resendInviteResponseSchema = z.object({
  inviteId: z.string(),
})

export type TResendInviteResponse = z.infer<typeof resendInviteResponseSchema>

export const getInviteResponseSchema = z.object({
  invite: inviteFullSchema,
})

export type TGetInviteResponse = z.infer<typeof getInviteResponseSchema>

export const listPendingInvitesResponseSchema = z.object({
  invites: z.array(inviteFullSchema),
})

export type TListPendingInvitesResponse = z.infer<
  typeof listPendingInvitesResponseSchema
>
